var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgStyling = function SvgStyling(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 25 24",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M18 11.217h-4.156L12.5 7l-1.344 4.217H7l3.544 2.566L8.956 18l3.544-2.567L16.044 18l-1.588-4.217L18 11.217Zm-1.134 3.29 3.397 9.017-7.763-5.621-7.763 5.621 3.397-9.017-7.306-5.29h8.866L12.5.417l2.806 8.8h8.866l-7.306 5.29Z"
  })));
};
export default SvgStyling;